import { render, staticRenderFns } from "./common_input.vue?vue&type=template&id=1dd31dd5&scoped=true"
import script from "./common_input.vue?vue&type=script&lang=js"
export * from "./common_input.vue?vue&type=script&lang=js"
import style0 from "./common_input.vue?vue&type=style&index=0&id=1dd31dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd31dd5",
  null
  
)

export default component.exports